import React, { useState } from "react";
import {
  ExpandableContainer,
  MainTitle,
  Description,
  TitleContent,
} from "./styles";
import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";

const Expandable = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <ExpandableContainer onClick={() => setExpanded(!expanded)}>
      <TitleContent>
        <MainTitle>{title}</MainTitle>
        {expanded ? (
          <RiArrowDownSLine size={38} color="#0041D9" />
        ) : (
          <RiArrowRightSLine size={38} color="#0041D9" />
        )}
      </TitleContent>
      {expanded && <Description>{description}</Description>}
    </ExpandableContainer>
  );
};

export default Expandable;
